import * as React from 'react';

import {SelectPickerGeneric} from 'shells/select-picker-generic/select-picker-generic';

const START_TIMES_OPTIONS = [
    {label: '15 minutes', value: 15},
    {label: '30 minutes', value: 30},
    {label: '60 minutes', value: 60},
];
type Props = {
    startTimeIntervalMinutes: number;
    onSave: (startTimeIntervalMinutes: number) => void;
    setSavingToastKey: (arg1: string) => void;
};

export function StartTimes(props: Props) {
    const [startTimeIntervalMinutes, setStartTimeIntervalMinutes] = React.useState<number>(
        props.startTimeIntervalMinutes
    );

    const onSave = (interval: number) => {
        props.setSavingToastKey('start-times');
        props.onSave(interval);
    };

    return (
        <SelectPickerGeneric
            placeholder='Start time interval'
            options={START_TIMES_OPTIONS}
            value={START_TIMES_OPTIONS.find((option) => option.value === startTimeIntervalMinutes)}
            // @ts-expect-error
            onChange={(interval) => {
                setStartTimeIntervalMinutes(interval.value);
                onSave(interval.value);
            }}
        />
    );
}
